<template>
  <div class="welcome container">
    <div class="card">
      <div class="card-content center-align">
        <h2 class="teal-text">Welcome</h2>
        <form @submit.prevent="enterChat">
          <label for="name">Enter your name</label>
          <input type="text" name="name" v-model="name">
          <p class="red-text" v-if="feedback">{{ feedback }}</p>
          <button class="teal btn">Enter Chat</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Welcome',
  data () {
    return {
      name: null,
      feedback: null
    }
  },
  methods: {
    enterChat() {
      if (this.name) {
        this.$router.push( {name: 'Chat', params: {name: this.name} })
      } else {
        this.feedback= "You must enter a name to join!"
      }
    }
  }
}
</script>

<style>
  .container {
    margin: 0 auto;
    width: 40%;
  }

  .welcome {
    margin-top: 1%;
  }

  .welcome h2 {

    font-size: 3em;

  }

  .welcome .card-content {
   padding-bottom: 57px;
  }

  .welcome button {
    margin: 1% auto;
  }

 

  @media screen and (max-width: 768px) {
    .container {
      width: 90%;
    }

    .welcome .card {
      box-shadow: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Welcome.vue